import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PhoneCall, ArrowUpRight } from "lucide-react";

export default function DashboardCalls() {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get("/calls/stats").then((r) => setStats(r.data)).catch(() => setStats(null)); }, []);

  const chips = [
    { key: "qualified", label: "Qualified", cls: "bg-emerald-50 text-emerald-700" },
    { key: "needs_review", label: "Needs review", cls: "bg-amber-50 text-amber-700" },
    { key: "declined", label: "Declined", cls: "bg-rose-50 text-rose-700" },
  ];

  return (
    <div className="bg-white border border-gray-200 rounded-sm shadow-sm p-6" data-testid="dashboard-calls">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading text-lg font-bold text-gray-900 flex items-center gap-2">
          <PhoneCall className="w-5 h-5 text-[#002FA7]" /> Calls
        </h3>
        <button onClick={() => navigate("/calls")} data-testid="dashboard-calls-open"
          className="text-xs font-semibold text-[#002FA7] hover:underline flex items-center gap-1">
          View all <ArrowUpRight className="w-3.5 h-3.5" />
        </button>
      </div>

      <div className="grid grid-cols-2 gap-3 mb-4">
        <div className="bg-[#002FA7]/5 rounded-sm p-3">
          <p className="font-heading text-3xl font-extrabold text-[#002FA7]" data-testid="calls-week-count">{stats?.this_week ?? "—"}</p>
          <p className="text-xs font-semibold text-gray-500">New this week</p>
        </div>
        <div className="bg-gray-50 rounded-sm p-3">
          <p className="font-heading text-3xl font-extrabold text-gray-900" data-testid="calls-converted-count">{stats?.converted ?? "—"}</p>
          <p className="text-xs font-semibold text-gray-500">Converted to intake</p>
        </div>
      </div>

      <div className="space-y-2" data-testid="calls-breakdown">
        {chips.map((c) => (
          <button key={c.key} onClick={() => navigate("/calls")}
            className="w-full flex items-center justify-between text-sm py-1.5 px-1 rounded-sm hover:bg-gray-50 transition-colors">
            <span className={`text-xs font-semibold px-2 py-0.5 rounded-sm ${c.cls}`}>{c.label}</span>
            <span className="font-bold text-gray-900">{stats?.[c.key] ?? 0}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
